'use strict';

(function () {

  angular
    .module('specsguardApp')
    .config(TenantsConfig);

  TenantsConfig.$inject = ['$stateProvider'];

  function TenantsConfig ($stateProvider) {

    $stateProvider.state('tenants/all', {
      url: '/tenants/all',
      templateUrl: 'app-legacy/tenants/tenants-overview.html',
      menu: {
        context: 'tenants-overview',
        title: '[Tenants]',
        icon: 'people',
        subtitle: '[Tenants overview]'
      },
      controller: 'TenantsOverviewCtrl',
      controllerAs: '$TenantsOverviewCtrl',
      authenticate: true,
      needRole: 1,
      resolve: {
        users: ['User', function (User) {
          return User.getAll({ tenantUsers: 'true' }).$promise;
        }],
        tenants: ['Tenant', function (Tenant) {
          return Tenant.getAllTenants().$promise;
        }],
      }
    });

    $stateProvider.state('tenants', {
      url: '/tenants',
      templateUrl: 'app-legacy/tenants/tenants.html',
      menu: {
        context: 'tenants',
        title: '[Tenants]',
        icon: 'people',
        subtitle: '[Tenants overview]'
      },
      controller: 'TenantsCtrl',
      controllerAs: '$TenantsCtrl',
      authenticate: true,
      needRole: 10,
      resolve: {
        // Just for building the md-chips
        users: ['User', function (User) {
          return User.getAll({ tenantUsers: 'true' }).$promise;
        }],
        // tenants are loaded accordingly
        tenants: ['Tenant', function (Tenant) {
          return Tenant.getAllTenants().$promise;
        }],
        allProjects: ['ProjectDataservice', function (ProjectDataservice) {
          return ProjectDataservice.getProjectList();
        }],
      }
    });
  }

})();


